import React, { useCallback } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { Col } from "antd";

import DynamicAxiosSelect from "containers/DynamicAxiosSelect";

function DynamicMultipleSelect({
  form,
  data,
  mode,
  index,
  value,
  method,
  maxTagCount,
  extra,
  help,
  onChange,
  // default
  className,
}) {
  const childClassNames = classNames(
    "custom-form-column",
    "dynamic-multiple-select-column",
    className,
  );

  const onlyRead = mode == "onlyRead" && data?.hasModeView;
  const isEdit = mode == "edit" || mode == "new";

  const emptyVal =
    data?.hiddenChain == "audience"
      ? {
          classes: [],
          courses: [],
          students: [],
          users: [],
          audiences: [],
          school: "",
        }
      : [];

  const onSearchCallback = useCallback(
    input => {
      data.onSearch !== undefined && data.onSearch(input);
    },
    [data.onSearch],
  );

  return (
    (data && (isEdit || onlyRead) && (
      <Col
        key={data?.name + index + "-col"}
        md={data?.col || 24}
        xs={24}
        offset={data?.offset || null}
        className={childClassNames}
      >
        <DynamicAxiosSelect
          mode={data?.mode}
          method={data?.method || "GET"}
          groupped={data?.groupped}
          className={data?.className + `${onlyRead ? " only-read" : ""}`}
          onlyRead={onlyRead}
          tagRender={data?.tagRender}
          showAsTag={data?.showAsTag}
          endponit={data?.endponit}
          placeholder={data?.placeholder}
          getResponse={data?.getResponse}
          onSearch={onSearchCallback}
          itemCallback={data?.itemCallback}
          value={value || data?.value}
          extra={extra || data?.extra}
          help={help || data?.help}
          item={data}
          isSearch={true}
          maxTagCount={data?.maxTagCount || maxTagCount}
          onSelect={data?.onSelect}
          onChange={(values, options) => {
            let init = {};
            if (Array.isArray(options) && options.length > 0) {
              options?.map(option => {
                if (option?.group && data?.hiddenChain) {
                  const arr = init[(option?.group)] || [];
                  let newArr = arr.concat([option.value]);
                  init[(option?.group)] = newArr;
                }
              });

              if (data?.hiddenChain && !!form) {
                form.setFieldsValue({
                  [data?.hiddenChain]: null,
                });
                form.setFieldsValue({
                  [data?.hiddenChain]: init,
                });
              }
            } else if (!!form) {
              init = emptyVal || null;
              data?.hiddenChain &&
                form.setFieldsValue({
                  [data?.hiddenChain]:
                    data?.hiddenChain == "audience" ? emptyVal : null,
                });
            }
            !!onChange && onChange(values, options, init);
          }}
        />
      </Col>
    )) ||
    false
  );
}

DynamicMultipleSelect.defaultProps = {
  index: 1,
  value: [],
  maxTagCount: 15, // responsive
};

DynamicMultipleSelect.propTypes = {
  data: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
};

export default DynamicMultipleSelect;
